import { jsx as g, Fragment as be, jsxs as Q } from "react/jsx-runtime";
import * as a from "react";
import E, { forwardRef as ye, useId as we } from "react";
import "react-dom";
function ee(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function I(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function Z(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function te(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((i) => {
      const r = Z(i, t);
      return !n && typeof r == "function" && (n = !0), r;
    });
    if (n)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const r = o[i];
          typeof r == "function" ? r() : Z(e[i], null);
        }
      };
  };
}
function D(...e) {
  return a.useCallback(te(...e), e);
}
function ne(e, t = []) {
  let n = [];
  function o(r, s) {
    const c = a.createContext(s), u = n.length;
    n = [...n, s];
    const d = (l) => {
      var p;
      const { scope: f, children: v, ...m } = l, h = ((p = f == null ? void 0 : f[e]) == null ? void 0 : p[u]) || c, S = a.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ g(h.Provider, { value: S, children: v });
    };
    d.displayName = r + "Provider";
    function y(l, f) {
      var h;
      const v = ((h = f == null ? void 0 : f[e]) == null ? void 0 : h[u]) || c, m = a.useContext(v);
      if (m) return m;
      if (s !== void 0) return s;
      throw new Error(`\`${l}\` must be used within \`${r}\``);
    }
    return [d, y];
  }
  const i = () => {
    const r = n.map((s) => a.createContext(s));
    return function(c) {
      const u = (c == null ? void 0 : c[e]) || r;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: u } }),
        [c, u]
      );
    };
  };
  return i.scopeName = e, [o, Ce(i, ...t)];
}
function Ce(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(r) {
      const s = o.reduce((c, { useScope: u, scopeName: d }) => {
        const l = u(r)[`__scope${d}`];
        return { ...c, ...l };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function re(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
function _e({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [o, i] = Re({ defaultProp: t, onChange: n }), r = e !== void 0, s = r ? e : o, c = re(n), u = a.useCallback(
    (d) => {
      if (r) {
        const l = typeof d == "function" ? d(e) : d;
        l !== e && c(l);
      } else
        i(d);
    },
    [r, e, i, c]
  );
  return [s, u];
}
function Re({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [o] = n, i = a.useRef(o), r = re(t);
  return a.useEffect(() => {
    i.current !== o && (r(o), i.current = o);
  }, [o, i, r]), n;
}
var xe = a.createContext(void 0);
function Pe(e) {
  const t = a.useContext(xe);
  return e || t || "ltr";
}
function Ee(e) {
  const t = a.useRef({ value: e, previous: e });
  return a.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var De = globalThis != null && globalThis.document ? a.useLayoutEffect : () => {
};
function Me(e) {
  const [t, n] = a.useState(void 0);
  return De(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const r = i[0];
        let s, c;
        if ("borderBoxSize" in r) {
          const u = r.borderBoxSize, d = Array.isArray(u) ? u[0] : u;
          s = d.inlineSize, c = d.blockSize;
        } else
          s = e.offsetWidth, c = e.offsetHeight;
        n({ width: s, height: c });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var B = a.forwardRef((e, t) => {
  const { children: n, ...o } = e, i = a.Children.toArray(n), r = i.find(Ie);
  if (r) {
    const s = r.props.children, c = i.map((u) => u === r ? a.Children.count(s) > 1 ? a.Children.only(null) : a.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ g(H, { ...o, ref: t, children: a.isValidElement(s) ? a.cloneElement(s, void 0, c) : null });
  }
  return /* @__PURE__ */ g(H, { ...o, ref: t, children: n });
});
B.displayName = "Slot";
var H = a.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if (a.isValidElement(n)) {
    const i = Oe(n), r = Ne(o, n.props);
    return n.type !== a.Fragment && (r.ref = t ? te(t, i) : i), a.cloneElement(n, r);
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
H.displayName = "SlotClone";
var Ae = ({ children: e }) => /* @__PURE__ */ g(be, { children: e });
function Ie(e) {
  return a.isValidElement(e) && e.type === Ae;
}
function Ne(e, t) {
  const n = { ...t };
  for (const o in t) {
    const i = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? i && r ? n[o] = (...c) => {
      r(...c), i(...c);
    } : i && (n[o] = i) : o === "style" ? n[o] = { ...i, ...r } : o === "className" && (n[o] = [i, r].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Oe(e) {
  var o, i;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Te = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], z = Te.reduce((e, t) => {
  const n = a.forwardRef((o, i) => {
    const { asChild: r, ...s } = o, c = r ? B : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(c, { ...s, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Ve(e) {
  const t = e + "CollectionProvider", [n, o] = ne(t), [i, r] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (v) => {
    const { scope: m, children: h } = v, S = E.useRef(null), p = E.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ g(i, { scope: m, itemMap: p, collectionRef: S, children: h });
  };
  s.displayName = t;
  const c = e + "CollectionSlot", u = E.forwardRef(
    (v, m) => {
      const { scope: h, children: S } = v, p = r(c, h), C = D(m, p.collectionRef);
      return /* @__PURE__ */ g(B, { ref: C, children: S });
    }
  );
  u.displayName = c;
  const d = e + "CollectionItemSlot", y = "data-radix-collection-item", l = E.forwardRef(
    (v, m) => {
      const { scope: h, children: S, ...p } = v, C = E.useRef(null), w = D(m, C), b = r(d, h);
      return E.useEffect(() => (b.itemMap.set(C, { ref: C, ...p }), () => void b.itemMap.delete(C))), /* @__PURE__ */ g(B, { [y]: "", ref: w, children: S });
    }
  );
  l.displayName = d;
  function f(v) {
    const m = r(e + "CollectionConsumer", v);
    return E.useCallback(() => {
      const S = m.collectionRef.current;
      if (!S) return [];
      const p = Array.from(S.querySelectorAll(`[${y}]`));
      return Array.from(m.itemMap.values()).sort(
        (b, R) => p.indexOf(b.ref.current) - p.indexOf(R.ref.current)
      );
    }, [m.collectionRef, m.itemMap]);
  }
  return [
    { Provider: s, Slot: u, ItemSlot: l },
    f,
    o
  ];
}
var oe = ["PageUp", "PageDown"], ie = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], se = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, N = "Slider", [W, ke, Be] = Ve(N), [ce, ft] = ne(N, [
  Be
]), [ze, K] = ce(N), ae = a.forwardRef(
  (e, t) => {
    const {
      name: n,
      min: o = 0,
      max: i = 100,
      step: r = 1,
      orientation: s = "horizontal",
      disabled: c = !1,
      minStepsBetweenThumbs: u = 0,
      defaultValue: d = [o],
      value: y,
      onValueChange: l = () => {
      },
      onValueCommit: f = () => {
      },
      inverted: v = !1,
      form: m,
      ...h
    } = e, S = a.useRef(/* @__PURE__ */ new Set()), p = a.useRef(0), w = s === "horizontal" ? Ke : Le, [b = [], R] = _e({
      prop: y,
      defaultProp: d,
      onChange: (_) => {
        var M;
        (M = [...S.current][p.current]) == null || M.focus(), l(_);
      }
    }), L = a.useRef(b);
    function $(_) {
      const x = We(b, _);
      O(_, x);
    }
    function ve(_) {
      O(_, p.current);
    }
    function ge() {
      const _ = L.current[p.current];
      b[p.current] !== _ && f(b);
    }
    function O(_, x, { commit: M } = { commit: !1 }) {
      const X = Xe(r), j = Ge(Math.round((_ - o) / r) * r + o, X), T = ee(j, [o, i]);
      R((A = []) => {
        const P = Fe(A, T, x);
        if (qe(P, u * r)) {
          p.current = P.indexOf(T);
          const G = String(P) !== String(A);
          return G && M && f(P), G ? P : A;
        } else
          return A;
      });
    }
    return /* @__PURE__ */ g(
      ze,
      {
        scope: e.__scopeSlider,
        name: n,
        disabled: c,
        min: o,
        max: i,
        valueIndexToChangeRef: p,
        thumbs: S.current,
        values: b,
        orientation: s,
        form: m,
        children: /* @__PURE__ */ g(W.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ g(W.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ g(
          w,
          {
            "aria-disabled": c,
            "data-disabled": c ? "" : void 0,
            ...h,
            ref: t,
            onPointerDown: I(h.onPointerDown, () => {
              c || (L.current = b);
            }),
            min: o,
            max: i,
            inverted: v,
            onSlideStart: c ? void 0 : $,
            onSlideMove: c ? void 0 : ve,
            onSlideEnd: c ? void 0 : ge,
            onHomeKeyDown: () => !c && O(o, 0, { commit: !0 }),
            onEndKeyDown: () => !c && O(i, b.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: _, direction: x }) => {
              if (!c) {
                const j = oe.includes(_.key) || _.shiftKey && ie.includes(_.key) ? 10 : 1, T = p.current, A = b[T], P = r * j * x;
                O(A + P, T, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
ae.displayName = N;
var [le, ue] = ce(N, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), Ke = a.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: o,
      dir: i,
      inverted: r,
      onSlideStart: s,
      onSlideMove: c,
      onSlideEnd: u,
      onStepKeyDown: d,
      ...y
    } = e, [l, f] = a.useState(null), v = D(t, (w) => f(w)), m = a.useRef(void 0), h = Pe(i), S = h === "ltr", p = S && !r || !S && r;
    function C(w) {
      const b = m.current || l.getBoundingClientRect(), R = [0, b.width], $ = q(R, p ? [n, o] : [o, n]);
      return m.current = b, $(w - b.left);
    }
    return /* @__PURE__ */ g(
      le,
      {
        scope: e.__scopeSlider,
        startEdge: p ? "left" : "right",
        endEdge: p ? "right" : "left",
        direction: p ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ g(
          de,
          {
            dir: h,
            "data-orientation": "horizontal",
            ...y,
            ref: v,
            style: {
              ...y.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (w) => {
              const b = C(w.clientX);
              s == null || s(b);
            },
            onSlideMove: (w) => {
              const b = C(w.clientX);
              c == null || c(b);
            },
            onSlideEnd: () => {
              m.current = void 0, u == null || u();
            },
            onStepKeyDown: (w) => {
              const R = se[p ? "from-left" : "from-right"].includes(w.key);
              d == null || d({ event: w, direction: R ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Le = a.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: o,
      inverted: i,
      onSlideStart: r,
      onSlideMove: s,
      onSlideEnd: c,
      onStepKeyDown: u,
      ...d
    } = e, y = a.useRef(null), l = D(t, y), f = a.useRef(void 0), v = !i;
    function m(h) {
      const S = f.current || y.current.getBoundingClientRect(), p = [0, S.height], w = q(p, v ? [o, n] : [n, o]);
      return f.current = S, w(h - S.top);
    }
    return /* @__PURE__ */ g(
      le,
      {
        scope: e.__scopeSlider,
        startEdge: v ? "bottom" : "top",
        endEdge: v ? "top" : "bottom",
        size: "height",
        direction: v ? 1 : -1,
        children: /* @__PURE__ */ g(
          de,
          {
            "data-orientation": "vertical",
            ...d,
            ref: l,
            style: {
              ...d.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (h) => {
              const S = m(h.clientY);
              r == null || r(S);
            },
            onSlideMove: (h) => {
              const S = m(h.clientY);
              s == null || s(S);
            },
            onSlideEnd: () => {
              f.current = void 0, c == null || c();
            },
            onStepKeyDown: (h) => {
              const p = se[v ? "from-bottom" : "from-top"].includes(h.key);
              u == null || u({ event: h, direction: p ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), de = a.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: n,
      onSlideStart: o,
      onSlideMove: i,
      onSlideEnd: r,
      onHomeKeyDown: s,
      onEndKeyDown: c,
      onStepKeyDown: u,
      ...d
    } = e, y = K(N, n);
    return /* @__PURE__ */ g(
      z.span,
      {
        ...d,
        ref: t,
        onKeyDown: I(e.onKeyDown, (l) => {
          l.key === "Home" ? (s(l), l.preventDefault()) : l.key === "End" ? (c(l), l.preventDefault()) : oe.concat(ie).includes(l.key) && (u(l), l.preventDefault());
        }),
        onPointerDown: I(e.onPointerDown, (l) => {
          const f = l.target;
          f.setPointerCapture(l.pointerId), l.preventDefault(), y.thumbs.has(f) ? f.focus() : o(l);
        }),
        onPointerMove: I(e.onPointerMove, (l) => {
          l.target.hasPointerCapture(l.pointerId) && i(l);
        }),
        onPointerUp: I(e.onPointerUp, (l) => {
          const f = l.target;
          f.hasPointerCapture(l.pointerId) && (f.releasePointerCapture(l.pointerId), r(l));
        })
      }
    );
  }
), fe = "SliderTrack", pe = a.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...o } = e, i = K(fe, n);
    return /* @__PURE__ */ g(
      z.span,
      {
        "data-disabled": i.disabled ? "" : void 0,
        "data-orientation": i.orientation,
        ...o,
        ref: t
      }
    );
  }
);
pe.displayName = fe;
var U = "SliderRange", me = a.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...o } = e, i = K(U, n), r = ue(U, n), s = a.useRef(null), c = D(t, s), u = i.values.length, d = i.values.map(
      (f) => Se(f, i.min, i.max)
    ), y = u > 1 ? Math.min(...d) : 0, l = 100 - Math.max(...d);
    return /* @__PURE__ */ g(
      z.span,
      {
        "data-orientation": i.orientation,
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: c,
        style: {
          ...e.style,
          [r.startEdge]: y + "%",
          [r.endEdge]: l + "%"
        }
      }
    );
  }
);
me.displayName = U;
var Y = "SliderThumb", he = a.forwardRef(
  (e, t) => {
    const n = ke(e.__scopeSlider), [o, i] = a.useState(null), r = D(t, (c) => i(c)), s = a.useMemo(
      () => o ? n().findIndex((c) => c.ref.current === o) : -1,
      [n, o]
    );
    return /* @__PURE__ */ g($e, { ...e, ref: r, index: s });
  }
), $e = a.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, index: o, name: i, ...r } = e, s = K(Y, n), c = ue(Y, n), [u, d] = a.useState(null), y = D(t, (C) => d(C)), l = u ? s.form || !!u.closest("form") : !0, f = Me(u), v = s.values[o], m = v === void 0 ? 0 : Se(v, s.min, s.max), h = He(o, s.values.length), S = f == null ? void 0 : f[c.size], p = S ? Ue(S, m, c.direction) : 0;
    return a.useEffect(() => {
      if (u)
        return s.thumbs.add(u), () => {
          s.thumbs.delete(u);
        };
    }, [u, s.thumbs]), /* @__PURE__ */ Q(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [c.startEdge]: `calc(${m}% + ${p}px)`
        },
        children: [
          /* @__PURE__ */ g(W.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ g(
            z.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || h,
              "aria-valuemin": s.min,
              "aria-valuenow": v,
              "aria-valuemax": s.max,
              "aria-orientation": s.orientation,
              "data-orientation": s.orientation,
              "data-disabled": s.disabled ? "" : void 0,
              tabIndex: s.disabled ? void 0 : 0,
              ...r,
              ref: y,
              style: v === void 0 ? { display: "none" } : e.style,
              onFocus: I(e.onFocus, () => {
                s.valueIndexToChangeRef.current = o;
              })
            }
          ) }),
          l && /* @__PURE__ */ g(
            je,
            {
              name: i ?? (s.name ? s.name + (s.values.length > 1 ? "[]" : "") : void 0),
              form: s.form,
              value: v
            },
            o
          )
        ]
      }
    );
  }
);
he.displayName = Y;
var je = (e) => {
  const { value: t, ...n } = e, o = a.useRef(null), i = Ee(t);
  return a.useEffect(() => {
    const r = o.current, s = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(s, "value").set;
    if (i !== t && u) {
      const d = new Event("input", { bubbles: !0 });
      u.call(r, t), r.dispatchEvent(d);
    }
  }, [i, t]), /* @__PURE__ */ g("input", { style: { display: "none" }, ...n, ref: o, defaultValue: t });
};
function Fe(e = [], t, n) {
  const o = [...e];
  return o[n] = t, o.sort((i, r) => i - r);
}
function Se(e, t, n) {
  const r = 100 / (n - t) * (e - t);
  return ee(r, [0, 100]);
}
function He(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function We(e, t) {
  if (e.length === 1) return 0;
  const n = e.map((i) => Math.abs(i - t)), o = Math.min(...n);
  return n.indexOf(o);
}
function Ue(e, t, n) {
  const o = e / 2, r = q([0, 50], [0, o]);
  return (o - r(t) * n) * n;
}
function Ye(e) {
  return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
function qe(e, t) {
  if (t > 0) {
    const n = Ye(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function q(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function Xe(e) {
  return (String(e).split(".")[1] || "").length;
}
function Ge(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
var Ze = ae, Je = pe, Qe = me, et = he;
function tt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var F = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var J;
function nt() {
  return J || (J = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var r = "", s = 0; s < arguments.length; s++) {
          var c = arguments[s];
          c && (r = i(r, o.call(this, c)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var s = "";
        for (var c in r)
          t.call(r, c) && r[c] && (s = i(s, this && this[c] || c));
        return s;
      }
      function i(r, s) {
        return s ? r ? r + " " + s : r + s : r;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(F)), F.exports;
}
var rt = nt();
const ot = /* @__PURE__ */ tt(rt), it = {
  "purpur-slider": "_purpur-slider_14tuk_1",
  "purpur-slider__track": "_purpur-slider__track_14tuk_17",
  "purpur-slider__range": "_purpur-slider__range_14tuk_17",
  "purpur-slider__thumb": "_purpur-slider__thumb_14tuk_43"
}, V = ot.bind(it), pt = ["horizontal", "vertical"], k = "purpur-slider", st = (e) => String(e), ct = ({
  "aria-label": e,
  "aria-valuetext": t,
  className: n,
  defaultValue: o,
  id: i,
  value: r,
  ...s
}, c) => {
  const u = we(), d = r || o;
  return /* @__PURE__ */ Q(
    Ze,
    {
      ...s,
      id: i || u,
      ref: c,
      className: V(k, n),
      value: r,
      defaultValue: o,
      children: [
        /* @__PURE__ */ g(Je, { className: V(`${k}__track`), children: /* @__PURE__ */ g(Qe, { className: V(`${k}__range`) }) }),
        d == null ? void 0 : d.map((y, l) => /* @__PURE__ */ g(
          et,
          {
            className: V(`${k}__thumb`),
            "aria-label": e,
            "aria-valuetext": t
          },
          st(l)
        ))
      ]
    }
  );
}, at = ye(ct);
at.displayName = "Slider";
export {
  pt as SLIDER_ORIENTATION,
  at as Slider
};
//# sourceMappingURL=slider.es.js.map
